import React, { useState } from "react";

const Navdata = () => {
  const [ui, setui] = useState(false);
  const [app, setapp] = useState(false);
  const [email, setemail] = useState(false);
  const [setcomponent] = useState(false);

  const [pages, setpages] = useState(false);
  const [auth, setauth] = useState(false);
  const [utility, setutility] = useState(false);

  const NavnavData = [
    {
      id: 1,
      label: "Dashboard",
      icon: "mdi mdi-home-variant-outline me-2",
      isdropDown: true,
      click: function () {
        setui(false);
        setapp(false);
        setcomponent(false);
        setpages(false);
      },
    },

    {
      id: 3,
      label: "Apps",
      icon: "ri-apps-2-line me-2",
      click: function () {
        setapp(!app);
        setui(false);
        setcomponent(false);
        setpages(false);
        setemail(false);
      },

      currentState: app,
      subItems: [
        {
          label2: "Calendar",
          url: "/calendar",
        },
      ],
    },

    {
      id: 5,
      label: "Pages",
      icon: "ri-file-copy-2-line me-2",
      click: function () {
        setpages(!pages);
        setui(false);
        setapp(false);
        setcomponent(false);

        setutility(false);
        setauth(false);
      },
      currentState: pages,
      subItems: [
        {
          label2: "Authentication",

          staclick: function () {
            setauth(!auth);
            setutility(false);

            setui(false);
            setapp(false);
            setcomponent(false);
          },
          subState: auth,
          subItem: [
            { link: "/auth-login", title: "Login" },
            { link: "/auth-register", title: "Register" },
            { link: "/auth-recoverpw", title: "Recover Password" },
            { link: "/auth-lock-screen", title: "Lock Screen" },
          ],
        },
        {
          label2: "Utility",
          staclick: function () {
            setutility(!utility);
            setauth(false);

            setui(false);
            setapp(false);
            setcomponent(false);
          },
          subState: utility,
          subItem: [
            { link: "/pages-starter", title: "Starter Page" },
            { link: "/pages-maintenance", title: "Maintenance" },
            { link: "/pages-comingsoon", title: "Coming Soon" },
            { link: "/pages-timeline", title: "Timeline" },
            { link: "/pages-faqs", title: "FAQs" },
            { link: "/pages-pricing", title: "Pricing" },
            { link: "/pages-404", title: "Error 404" },
            { link: "/pages-500", title: "Error 500" },
          ],
        },
      ],
    },
  ];
  return <React.Fragment>{NavnavData}</React.Fragment>;
};

export default Navdata;
